import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../Navbar/Navbar";
import MensajeToken from "../MensajeToken/MensajeToken";

export default function Layout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [validando, setValidando] = useState(true);
  const [tokenError, setTokenError] = useState("");

  const logout = () => {
    localStorage.removeItem("auth_usuario");
    localStorage.removeItem("userName");
    navigate("/login");
  };

  useEffect(() => {
    const verificarToken = async () => {
      const token = localStorage.getItem("auth_usuario");

      if (!token) {
        navigate("/login");
        return;
      }

      try {
        await axios.get(`${process.env.REACT_APP_BASE_URL}/auth`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setValidando(false);
      } catch (error) {
        const mensaje = error.response?.data?.message || "Tu sesión expiró.";
        setTokenError(mensaje);
        setValidando(false);
      }
    };

    verificarToken();
  }, [navigate]);

  if (validando) {
    return (
      <div className="flex items-center justify-center h-screen bg-slate-50">
        <div className="flex flex-col items-center gap-4">
          <div className="w-8 h-8 border-4 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
          <div className="text-slate-500 font-bold text-xs uppercase tracking-widest animate-pulse">
            Verificando sesión...
          </div>
        </div>
      </div>
    );
  }

  if (tokenError) {
    return <MensajeToken mensajeError={tokenError} logout={logout} />;
  }

  // return (
  //   // h-screen + overflow-hidden asegura que la app se comporte como una sola pieza
  //   <div className="h-screen flex flex-col bg-slate-50 overflow-hidden">
  //     <Navbar logout={logout} />

  //     {/* pt-14: Empieza justo después de la h-14 del Navbar.
  //         flex-1: Toma todo el espacio restante.
  //         overflow-y-auto: Solo esta parte tendrá scroll si el contenido es largo (como la tabla).
  //     */}
  //     <main className="flex-1 pt-14 overflow-y-auto">
  //       <div className="max-w-7xl mx-auto h-full">
  //          <Outlet />
  //       </div>
  //     </main>
  //   </div>
  // );

  // Título de la sección actual para la barra superior de escritorio
  const ruta = location.pathname;
  const encabezado =
    ruta.includes("editar-servicio") ? { titulo: "Editar servicio", sub: "Modificar un registro del historial" } :
    ruta.includes("ver-servicios") ? { titulo: "Historial de servicios", sub: "Control de servicios técnicos y recambios de pezoneras" } :
    ruta.includes("carga-cliente") ? { titulo: "Nuevo cliente", sub: "Alta de un establecimiento" } :
    ruta.includes("ver-clientes") ? { titulo: "Lista de clientes", sub: "Consulta, edición y baja de clientes" } :
    { titulo: "Nuevo servicio", sub: "Registrar una visita técnica" };

  return (
    // Estructura tipo aplicación de escritorio: ocupa toda la pantalla y
    // solo scrollea el contenido interno de cada sección.
    <div className="h-screen flex bg-slate-50 overflow-hidden">
      <Navbar logout={logout} />

      <div className="flex-1 min-w-0 flex flex-col">
        {/* Barra superior de escritorio */}
        <header className="hidden lg:flex h-14 shrink-0 items-center justify-between px-6 bg-white border-b border-slate-200">
          <div>
            <h1 className="text-[15px] font-black text-slate-900 uppercase tracking-tight leading-tight">{encabezado.titulo}</h1>
            <p className="text-[11px] text-slate-400 font-medium">{encabezado.sub}</p>
          </div>
          <span className="text-[11px] font-black text-slate-400 uppercase tracking-[0.2em]">Servicios GEA</span>
        </header>

        {/* En mobile dejamos lugar para la barra fija (h-14) */}
        <main className="flex-1 min-h-0 overflow-y-auto scroll-fino pt-14 lg:pt-0">
          <div className="h-full p-3 md:p-4 lg:p-5">
            <Outlet />
          </div>
        </main>
      </div>
    </div>
  );

}